// Cache da marca da empresa usado na tela de abertura.
// Na 1ª visita não existe cache e a abertura padrão (AG.SIM) é exibida.
// Toda vez que os dados da empresa chegam da API o cache é regravado, então
// mudanças de nome, logo ou cor aparecem já na próxima abertura.

export interface MarcaAbertura {
  nome: string;
  logo: string;
  cor: string;
  legado: boolean; // pwa simples / layout v2 / tema escuro usam a abertura padrão
}

const PREFIXO = "abertura_empresa_";

// Mesma regra usada para buscar a empresa: subdomínio da URL, ou o parâmetro
// ?subdomain= quando acessado por cliente.agendasimplificada...
export function obterSubdominio(): string {
  const url = window.location.href;
  let subdomain = url.split("/")[2].split(".")[0];

  if ("cliente".includes(subdomain)) {
    const urlParams = new URLSearchParams(window.location.search);
    const sub = urlParams.get("subdomain");
    subdomain = sub ? sub : "";
  }

  return subdomain;
}

export function lerCacheAbertura(): MarcaAbertura | null {
  try {
    const valor = window.localStorage.getItem(PREFIXO + obterSubdominio());
    if (!valor) return null;

    const marca = JSON.parse(valor);
    if (!marca || !marca.cor) return null;

    return marca;
  } catch (error) {
    return null;
  }
}

export function salvarCacheAbertura(marca: MarcaAbertura) {
  try {
    window.localStorage.setItem(
      PREFIXO + obterSubdominio(),
      JSON.stringify(marca),
    );
  } catch (error) {
    // sem cache disponível (aba anônima, armazenamento bloqueado): segue sem cache
  }
}

export function limparCacheAbertura() {
  try {
    window.localStorage.removeItem(PREFIXO + obterSubdominio());
  } catch (error) {
    // ignora
  }
}
